import script from "./JobRequirements.vue?vue&type=script&lang=ts&setup=true"
export * from "./JobRequirements.vue?vue&type=script&lang=ts&setup=true"

import "./JobRequirements.vue?vue&type=style&index=0&id=539dc36f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-539dc36f"]])

export default __exports__